module.exports = __webpack_public_path__ + "static/media/food2.15e53ae1.png";